<template>
  <div>
    <VBox :scrollable="true">
      <b-container fluid>
        <b-row>
          <b-col>
            <b-container class="pt-4">
              <b-row cols="8">
                <b-col>
                  <b-form-group>
                    <FileUpload
                        ref="importDataUpload"
                        data-test-path="import-data-upload"
                        @file-selected="importDataFileSelected"
                    >
                    </FileUpload>
                  </b-form-group>
                  <div class="text-center" v-if="loading">
                    <span>{{ percentDone }} %</span>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="pt-4" v-if="!allBugs.length  && fileIsReady" data-test-path="file-upload-info">
                  <div v-if="numberOfImportedRecords !== 0">{{$tr('importFormData.file-Loaded-Successfully','The file has been loaded successfully.')}}</div>
                  <div v-if="numberOfImportedRecords !== 0">{{ numberOfImportedRecords }} {{$tr('importFormData.records-imported','records have been imported.')}}
                  </div>
                </b-col>
                <b-col class="pt-4" v-if="allBugs.length">
                  {{$tr('importFormData.errors','Errors')}}:
                  <b-container>
                    <b-row v-for="bug of allBugs" :key="bug.id">
                      {{ bug }}
                    </b-row>
                  </b-container>
                </b-col>
                <b-col class="pt-4" v-else-if="info.length">
                  {{$tr('importFormData.Warnings','Warnings')}}:
                  <b-container>
                    <b-row v-for="information of info" :key="information.id">
                      {{ information }}
                    </b-row>
                  </b-container>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
        </b-row>
      </b-container>
    </VBox>
    <FooterNavbar data-test-path="import-products-footer">
      <CloseButton @close="close"></CloseButton>
    </FooterNavbar>
  </div>
</template>
<script>

import Activity from "@/activity/Activity";
import FileUpload from "@/components/FileUpload";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import CloseButton from "@/components/navbar/CloseButton";
import VBox from "@/components/VBox";
import moment from "moment-timezone";
import DialogManager from "@/utils/DialogManager";
import FormsActions from "@/components/forms/FormsActions";
import Season from "@/server/com/silkplm/model/plm/Season";
import EventBus from "@/utils/EventBus";
import Events from "@/utils/Events";

moment.suppressDeprecationWarnings = true;

export default {
  name: "ImportFormData",
  components: {CloseButton, FooterNavbar, FileUpload, VBox},


  async mounted() {
    this.userLocale = window.navigator.language;

    if (this.dataLoad) {
      await this.dataLoad();
    }
  },

  methods: {

    ...Activity.methods,

    getTitle() {
      return this.title;
    },

    async importDataFileSelected() {
      let fileUpload = this.$refs.importDataUpload;
      let file = fileUpload.getFile();
      this.loading = true;
      fileUpload.setProgress(0);
      try {
        let result = null;
        if (this.uploadData) {
          result = await this.uploadData(file, fileUpload);
        } else {
          result = await Rpc.plm.DataImport.importData(file, this.formClassLong, this.masterId).lock().onProgress((e) => {
            fileUpload.setProgress(e.percent);
            this.percentDone = Math.floor(e.percent);
          });
        }
        this.info = result.info;
        this.allBugs = result.bugs;
        this.numberOfImportedRecords = result.numberOfImportedRecords;
        this.fileIsReady = true;
        this.loading = false;
        this.percentDone = 0;
        fileUpload.reset();
      } catch (e) {
        this.loading = false;
        this.percentDone = 0;
        if (e instanceof RpcInputValidationException) {
          fileUpload.setError(e.fields.$field.errorMessage);
          this.allBugs = 0;
          this.fileIsReady = false;
        }
      }
      if (this.allBugs?.length) {
        await DialogManager.info($tr('importFormData.error-file-import','File import error'),
            $tr('importFormData.info-file-cannot-imported','The file cannot be imported because it contains errors.'));
      }
    }

  },

  props: {
    title: {type: String, default: ""},
    formClassLong: {type: String, default: ""},
    masterId: {type: String, default: ""},
    uploadData: {type: Function, default: null},
  },

  data: () => ({
    userLocale: null,
    allBugs: [],
    info: [],
    fileIsReady: false,
    loading: false,
    percentDone: 0,
    numberOfImportedRecords: 0,
  }),

}
</script>
